.card {
  display: block;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  min-inline-size: 0;
}

.padded {
  padding: var(--space-4);
}

.cardHeader {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-block-size: 48px;
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border);
}
